import React from 'react';
import { Radio, FormControlLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Importing a MUI icon
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; // Importing unchecked icon

// Custom Radio Button Icon
const CustomRadioIcon = ({ checked }) => (
  <>
    {checked ? (
      <CheckCircleIcon sx={{ color: '#3D5A96', fontSize: '24px' }} />
    ) : (
      <RadioButtonUncheckedIcon sx={{ color: '#ccc', fontSize: '24px' }} />
    )}
  </>
);

// Reusable Custom Radio Button Component
const CustomRadioButton = ({ label, sublabel, value, checked, onChange, name }) => {
  return (
    <FormControlLabel
      control={
        <Radio
          sx={{ display: 'none' }}
          value={value}
          checked={checked}
          onChange={onChange}
          name={name}
        />
      }
      label={
        <span
          onClick={() => onChange({ target: { value, name } })}
          style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', marginBottom:0}}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CustomRadioIcon checked={checked} />
            <span style={{ marginLeft: '8px' }}>{label}</span> {/* Margin between icon and label */}
          </div>
          {sublabel && (
            <span style={{ marginLeft: '32px', fontSize: '16px', color: '#667085', marginTop: '0px', fontWeight:300 }}>
              {sublabel}
            </span>
          )}
        </span>
      }
      sx={{ marginLeft: '0px' }}
    />
  );
};

export default CustomRadioButton;
